import React from "react";

import { Mail } from "lucide-react";

import PageHeader from "../../Components/PageHeader";
import EmailActivityContainer from "../../Container/EmailActivityContainer";

const EmailActivity: React.FC = () => {
  return (
    <div className="w-full bg-white overflow-hidden mt-3">
      <PageHeader
        title="Email Activity"
        icon={Mail}
        subTitle="View sent emails and filter by recipient or type."
      />
      <div className="w-full bg-white p-3 md:p-4">
        <div className="w-full rounded-md bg-gray-100 p-4 md:p-4">
          <EmailActivityContainer />
        </div>
      </div>
    </div>
  );
};

export default EmailActivity;
